import { NativeModules, Platform } from 'react-native';

interface AppleReceiptFetcherInterface {
  fetchAppReceiptBase64(): Promise<string>;
}

const LINKING_ERROR =
  `The package 'AppleReceiptFetcher' doesn't seem to be linked. Make sure: \n\n` +
  Platform.select({ ios: "- You have run 'pod install'\n", default: '' }) +
  '- You rebuilt the app after installing the package\n' +
  '- You are running on a physical iOS device or simulator\n';

const AppleReceiptFetcherModule: AppleReceiptFetcherInterface =
  NativeModules.AppleReceiptFetcher
    ? NativeModules.AppleReceiptFetcher
    : new Proxy(
        {},
        {
          get() {
            throw new Error(LINKING_ERROR);
          },
        }
      );

export class AppleReceiptFetcher {
  static async fetchAppReceiptBase64(): Promise<string | null> {
    if (Platform.OS !== 'ios') {
      console.warn('AppleReceiptFetcher is only available on iOS');
      return null;
    }

    try {
      const receipt = await AppleReceiptFetcherModule.fetchAppReceiptBase64();
      return receipt;
    } catch (error) {
      console.error('Failed to fetch Apple receipt:', error);
      return null;
    }
  }

  static isAvailable(): boolean {
    return Platform.OS === 'ios' && !!NativeModules.AppleReceiptFetcher;
  }
}

export default AppleReceiptFetcher;
